import { api } from "@/utils/client";
import { keyBy, sortBy } from 'lodash-es';
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        ids: [],
        list: {},
        meta: {},
        history: [],
        selected: undefined,
    },
    getters: {
        orderedList(state) {
            return state.ids.map(id => state.list[id]);
        },
        selected(state) {
            return state.list[state.selected];
        }
    },
    mutations: {
        reset(state) {
            state.ids = [];
            state.list = {};
            state.meta = {};
            state.history = [];
            state.selected = undefined;
        },
        setList(state, list) {
            state.ids = sortBy(list, 'order').map(({id}) => id)
            state.list = keyBy(list, 'id');
        },
        setIds(state, ids) {
            state.ids = ids;
        },
        addItem(state, {id, ...item}) {
            state.ids = [...state.ids, id];
            Vue.set(state.list, id, {id, ...item})
        },
        updateItem(state, {id, ...item}) {
            Vue.set(state.list, id, {id, ...item})
        },
        removeItem(state, id) {
            state.ids = state.ids.filter((_id) => _id !== id);
            Vue.delete(state.list, id)
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        setSelected(state, selected) {
            state.selected = selected;
        },
        addToHistory(state, {id, questions}) {
            state.history.push({
                id: id,
                questions: questions
            });
        }
    },
    actions: {
        reset({commit}) {
            commit('reset');
        },
        async getList({commit, state, rootState}, params = {}) {
            const {data: {data, meta}} = await api.get(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/pages`, {
                params: {
                    ...params,
                    deleted: state.showingDeleted ? 1 : 0
                }
            })
            commit('setList', data);
            commit('setMeta', meta);
            return data;
        },
        async getById({commit, rootState, state}, id) {
            const {data: {data}} = await api.get(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/pages/${id}`,)
            commit('updateItem', data);
            if (id === state.selected) {
                commit('surveyQuestions/setList', data.questions, {root: true})
            }
            return data;
        },
        async create({commit, rootState}, payload) {
            const {data: {data}} = await api.post(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/pages`, payload)
            commit('addItem', data);
            return data;
        },
        async update({commit, rootState}, {id, ...payload}) {
            const {data: {data}} = await api.put(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/pages/${id}`, payload)
            commit('updateItem', data);
            return data;
        },
        async delete({commit, rootState}, id) {
            const {data: {data}} = await api.delete(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/pages/${id}`)
            commit('updateItem', data);
            return data;
        },
        async restore({commit, rootState}, id) {
            const {data: {data}} = await api.put(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/pages/${id}/restore`)
            commit('updateItem', data);
            return data;
        },
        async forceDelete({commit, rootState}, id) {
            const {data: {data}} = await api.delete(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/pages/${id}`, {data: {permanent: true}})
            commit('removeItem', id);
            return data;
        },
        async reorder({commit, rootState, state, getters}, ids) {
            commit('setList', ids.map((id, index) => ({
                ...state.list[id],
                order: index + 1
            })))

            const payload = getters.orderedList.map(({id, order}) => ({id, order}));
            const {data: {data}} = await api.patch(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/pages`, payload)
            commit('addItem', data);
        },
        async selectPreviousPage({commit, rootState}) {
            rootState.surveyPages.history.pop();
            const { id, questions } = rootState.surveyPages.history.slice(-1)[0];
            commit('setSelected', id)
            commit('surveyQuestions/setList', questions, {root: true})
            if (rootState.surveyResponses.selected) {
                api.post(`/surveys/${rootState.surveys.selected}/responses/${rootState.surveyResponses.selected}/pages/${id}`, {})
            }
        },
        async selectPage({commit, rootState}, {id, questions}) {
            commit('addToHistory', {id, questions});
            commit('setSelected', id)
            commit('surveyQuestions/setList', questions, {root: true})
            if (rootState.surveyResponses.selected) {
                api.post(`/surveys/${rootState.surveys.selected}/responses/${rootState.surveyResponses.selected}/pages/${id}`, {})
            }
        },

        
    }

}
